var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollComparison",staticClass:"lite-compare-header-mobile"},[_c('div',{ref:"scrollComparisonWrap",staticClass:"lite-compare-header-mobile__scroll",attrs:{"data-fix-on-scroll":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }